import axios  from "axios"

export default {
    async addFarm(data) {
        return await axios.post('farm', data)
            .then(result => result.data)
            .catch( error => Promise.reject(error.response));
    },
    async loadoptions(data) {
        return await axios.post('/option', data)
            .then(({data}) => data)
            .catch( error => Promise.reject(error));
    },
    async loadUsers() {
        return await axios.get('/option/user?page=1&limit=1000')
            .then(({data}) => data)
            .catch( error => Promise.reject(error));
    },
    async loadCountries() {
        return await axios.get('/option/country')
            .then((data) =>data.data )
            .catch( error => Promise.reject(error));
    },
    async loadStates(id) {
        let url=`/option/state?country=${id}`
        return await axios.get(url)
            .then((data) =>data.data )
            .catch( error => Promise.reject(error));
    },
    async loadCities(id) {
        let url=`/option/city?state=${id}`
        return await axios.get(url)
            .then((data) =>data.data )
            .catch( error => Promise.reject(error));
    },
    async getfarms(dataOptions,search) {
        var url = `farm?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if(search != '')
            url = `${url}&search=${search}`
            if(dataOptions.sortBy.length)
            url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },
    async getfarm(id) {
        var url = `farm/${id}`
        return await axios.get(url)
        .then(({data}) => data.data)
        .catch( error => Promise.reject(error));
    },
    async editfarm(data) {
        var url = `farm/`
        return await axios.put(url, data)
        .then((result) => result.data)
        .catch( error => Promise.reject(error.response));
    },

    async searchFarms(search="") {
        var url = "/option/farm/list?page=1&limit=1000"
        if(search?.length > 0)
            url = `${url}&search=${search}`
        return await axios.get(url)
            .then(({data}) => data)
            .catch( error => Promise.reject(error));
    },
    async searchUsers(search="") {
        var url='/option/user?page=1&limit=1000'
        if(search.length > 0)
            url = `${url}&search=${search}`
        return await axios.get(url)
            .then(({data}) => data)
            .catch( error => Promise.reject(error));
    },

    async assingUsers(farmId, users) {
        return axios.put('/farm/assignusers/'+farmId, {
            users
        }).then(({data}) => {
            return Promise.resolve(data)
        })
        .catch(e => {
            return Promise.reject(e)
        })
    }
}